export default __webpack_public_path__ + "static/media/goshen4.7b7c9613.jpg";